<template>
  <div class="row" :class="errorClass" v-if="displayField">
    <div class="col-md-4 col-lg-4 col-xl-3">
      <label class="h6 text-md-right">
        <span v-html="label"></span> <br>
        <small class="text-black-50">{{labelSecondary}}</small>
      </label>
    </div>
    <div class="col-md-8 col-lg-8 col-xl-9">
      <select v-model="selected" @change="getHgh5Cards($event)" ref="ecards">
        <option class="list-group-item" v-for="info in behaviours" :value="info.id" v-bind:key="info.id"> 
          {{ info.name }}
        </option>
      </select> 
      <vue-select-image :dataImages="dataImages" @onselectimage="onSelectImage($event)" h="250px"></vue-select-image>
      <div v-if="errorClass !== ''" class="alert alert-danger mt-1" role="alert">
        Please select behaviour Card
      </div>
    </div> 
  </div>
</template>

<script>
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import VueSelectImage from 'vue-select-image'
require('vue-select-image/dist/vue-select-image.css')

export default {
  props: [
    'label',
    'labelSecondary',
    'isRequired',
    'displayField',
    'errorClass'
  ],
  data () {
    return {
      behaviours:null,
      behavioursChild:null,
      dataImages:[] ,
      parentcategory:null,
      selected: ""
    }
  },
  components: {
    VueSelectImage
  },
  created () {
    var self = this
    WordpressRestAPI.getViewContent('bigups_ecards?parent=0')
      .then(function (response) {
        self.behaviours = response.data
      })
      .catch(function (e) {
        console.error(e)
      })
  },
  methods: {
   getHgh5Cards(elem, target = 'elem') {
    var self = this
    if (target === 'refs') {
      self.parentcategory = elem[0].value
    } else {
      self.parentcategory = elem.target.value
    }
     WordpressRestAPI.getViewContent('bigups_ecards?parent=' + elem.target.value)
      .then(function (response) {
        self.behavioursChild = response.data
        self.dataImages = []
        for (var i = 0; i < self.behavioursChild.length; i++) {
          self.dataImages.push({id: self.behavioursChild[i].id, src: self.behavioursChild[i].cover_image, alt: self.behavioursChild[i].name})
        }
      })
      .catch(function (e) {
        console.error(e)
      })
    },
    onSelectImage(dataImages) {
      this.$emit('selectedBehaviour', {label: this.label, content: dataImages.id, validated: true, category: 'high5', parentcategory: this.parentcategory, displayField: this.displayField, parentName: this.behaviours.filter(x => x.id == this.parentcategory)[0].name})
    },
    changeUser(value) {
      this.info.id = value;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FieldHigh5Cards.vue